<section class="section-apresentation" id="apresentation">
  <div class="apresentation-overlay"></div>
  <div class="apresentation-content">
    <div class="apresentation-label">
      <h4>breakers</h4>
      <p class="apresentation-subtitle">a queda das chamas</p>
    </div>
    <div class="apresentation-title">
      <h1 class="apresentation-tagline"> A Saga Elemental </h1>
      <h4 class="apresentation-tagline">Inicia-se aqui</h4>
    </div>
    <p class="apresentation-description">
      Depois de quatro anos em coma, Henshi acorda com uma lembrança que não o abandona: A morte de seus pais — os Imperadores do Reino do Fogo.
      Mas o mundo que ele encontra já não é o mesmo. Sem líderes, sem ordem, sem limites.
      O caos se espalha pelas ruas, e cada resposta encontrada abre uma nova ferida. Descubra o começo de uma história que não se limita à lembrança — ela começa na verdade. <br/>
      Está pronto para enfrentar essa jornada?
    </p>
    <div class="apresentation-buttons">
      <a role="button" class="yellow-button" (click)="scrollToIdOnClick($event)" href="#compra">compre</a>
      <a role="button" class="outline-button" (click)="goToPreview()">Ler preview grátis</a>
    </div>
  </div>
  <img src="assets/images/capa-breakers.jpg" alt="Capa Breakers" class="apresentation-cover">
</section>
